import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { AccountService } from 'src/app/services/account.service';

@Component({
  selector: 'app-mark-as-paid',
  templateUrl: './mark-as-paid.component.html',
  styleUrls: ['./mark-as-paid.component.css']
})
export class MarkAsPaidComponent implements OnInit {
  markaspaidForm: UntypedFormGroup;
  submitbtnDisabled = false;
  formErrors = {
    'collectedDate': '',
    'collectedBy': '',
    'acceptPaymentBy': '',
    'amountToPay': ''



  };
  ValidationMessages = {
    'collectedDate': {
      'required': 'collected date is Required',
    },
    'collectedBy': {
      'required': 'Collected by is Required'
    },
    'acceptPaymentBy': {
      'required': 'payment mode is Required'
    }
  };
  invoiceDue: any;
  api_success: string;
  api_error: any;
  uuid: any;
  showNoteSection: boolean;
  type: any;
  collectedBy: boolean;
  note: boolean;
  action: any;
  disableConfirmbtn = false;
  constructor(private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formbuilder: UntypedFormBuilder, private accountService: AccountService) {
    this.markaspaidForm = this.formbuilder.group({
      collectedBy: ['', Validators.required],
      collectedDate: ['', [Validators.required]],
      acceptPaymentBy: ['cash', Validators.required],
      note: [''],
      amountToPay: [''],
      uuid: this.data.ynwUuid
    });
  }

  ngOnInit() {
    console.log(this.data.details)
    if(this.data && this.data.type){
      this.type = this.data.type;
    }
   if(this.data && this.data.action){
    this.action = this.data.action;
   }
    if(this.data && this.data.details){
      this.showNoteSection =  true;
      if(this.type === 'collectedBy'){
        this.collectedBy = true;
        this.note = false;
      }
      else if(this.type === 'note'){
        this.collectedBy = false;
        this.note = true;
      }
     
    }
    if(this.action === 'edit'){
      this.markaspaidForm.patchValue({
       
        collectedBy: this.data.details.collectedBy,
        // privateNote: this.details.privateNote
      });
    }
  
    this.invoiceDue = this.data.amountToPay;
    // const today = new Date().toISOString().split('T')[0];
    // document.getElementsByName('setTodaysDate')[0].setAttribute('max', today);

  }

  OnPaymentSubmit() {
    this.api_error = '';
    this.api_success = '';
    this.submitbtnDisabled = true;
    this.accountService.markAsPaid(this.markaspaidForm.value)
      .subscribe(data => {
        this.submitbtnDisabled = false;
        this.api_success = 'Invoice paid Successfully';
        setTimeout(() => {
          this.dialogRef.close('reloadlist');
        }, 2000);
      },
        (error) => {
          this.submitbtnDisabled = false;
          this.api_error = error.error;
        }
      );
  }
  noteUpdate(){
    
    const data = {
      'collectedBy': this.markaspaidForm.get('collectedBy').value,
      'uuid': this.data.details.ynwUuid,
      'paymentId': this.data.details.id,
      // 'collectedDate': '2023-04-06',
     
    
      'note': this.markaspaidForm.get('note').value

    };
    console.log(data)
    this.accountService.noteUpdate(data)
    .subscribe(res => {
      this.api_success = 'Note updated successfully';
      setTimeout(() => {
        this.dialogRef.close('reloadlist');
        }, 2000);
    },
      (error) => {
        this.disableConfirmbtn = false;
        this.api_error = error.error;
       }
    );
  }

}
